import React, { Component } from 'react';
import logo from '../images/logo.svg';

import homeIcon from '../icons/menu/baseline-home.svg';
import businessIcon from '../icons/menu/baseline-business.svg';
import exitIcon from '../icons/menu/baseline-exit.svg';
import serviceIcon from '../icons/menu/treatment.png';
import chartIcon from '../icons/menu/chart-line.svg';
import flaskIcon from '../icons/menu/flask.svg';
import headsetBlackIcon from '../icons/menu/headset-black.svg'
import Login from './Login'
import loginIcon from '../icons/menu/user.svg'


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faAngleDown, faAngleRight} from '@fortawesome/free-solid-svg-icons'

import '../styles/Header.css';
import {
    NavLink
  } from "react-router-dom";
import PropTypes from 'prop-types'
import * as urlLogin from '../config/urlLogins.js';

const ArrowMenu = ({ filled, onClick }) => {
    return (
        <div onClick={onClick} class="arrow-menu-container">
            <FontAwesomeIcon icon={filled ? faAngleDown : faAngleRight}/>
        </div>
    );
};

class Header extends Component {
	state = { filled: false };
    constructor(){
        super();
        this.openLoginMobile = this.openLoginMobile.bind(this)
	}
	static contextTypes = {
        router: PropTypes.object
    }
    redirectToHome = () => {
        this.context.router.history.push(`/`)
    }
    handleClick = () => {
        this.setState({ filled: !this.state.filled });
        let modeloMenu = document.getElementById("modelo-menu")
        if(modeloMenu.classList.contains("modelo-visible")){
            modeloMenu.style.width = "0";
            modeloMenu.style.height = "0";
            modeloMenu.classList.remove('modelo-visible');
        }else{
            modeloMenu.style.width = "200%";
            modeloMenu.style.height = "10%";
            modeloMenu.classList.add('modelo-visible');
        }
    }
    toggleLogin = () =>{
        this.setState({ filled: !this.state.filled });
        let modeloMenu = document.getElementById("modelo-menu-dos")
        if(modeloMenu.classList.contains("modelo-visible")){
            modeloMenu.style.width = "0";
            modeloMenu.style.height = "0";
            modeloMenu.classList.remove('modelo-visible');
        }else{
            modeloMenu.style.width = "200%";
            modeloMenu.style.height = "100px";
            modeloMenu.classList.add('modelo-visible');
        }
    }
    openNav () {
        let menuMobile = document.getElementById("mySidenav")
        menuMobile.style.width = "80%";
        menuMobile.style.zIndex = "2";
        let overlay = document.getElementById("overlay")
        overlay.style.backgroundColor = "rgba(0,0,0,0.7)"
        overlay.style.zIndex = "1"
    }
    closeNav () {
        setTimeout(
            function() {
                document.getElementById("mySidenav").style.width = "0";
                let overlay = document.getElementById("overlay")
                overlay.style.backgroundColor = "unset"
                overlay.style.zIndex = "-2"
            }, 200);
        
    }
    openLogin(){
        let loginModal = document.getElementById("ingresarPanel")
        loginModal.style.display = "block"

        let overlay = document.getElementById("overlay")
        overlay.style.zIndex = "1"
    }
    openLoginMobile(){
        this.openLogin()
        this.closeNav()
    }
    render(){
        return (
        <div>
        <div class="header-bg" id="myHeader">
            <div class="logo-container">
                <img src={logo} onClick={this.redirectToHome}/>
            </div>
            <div class="menu-buttons">
                <NavLink exact to="/">INICIO</NavLink>
                <NavLink to="/empresa">EMPRESA</NavLink>
                <NavLink to="/servicios">SERVICIOS</NavLink>
                <NavLink to="/ventajas">VENTAJAS</NavLink>
                <NavLink to="/laboratorios">LABORATORIOS</NavLink>
                <NavLink to="/contacto">CONTACTO</NavLink>
                <div class="btn-container-rectangle">
                    <button class="rectangle" onClick={this.openLogin}>
                    <p>INGRESAR</p>
                    </button>
                    <div class="ingresar-panel modal" id="ingresarPanel">
                        <a target="_blank" rel="noopener noreferrer" href={urlLogin.TRANSFERS}>
                            <p class="text-transfer">TRANSFER</p>
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href={urlLogin.PORTALDROGUERIAS}>
                            <p class="text-portal">DROGUERIAS</p>
                        </a>
                    </div>
                </div>
            </div>
            
            <a class="icon" onClick={this.openNav}>
                <FontAwesomeIcon icon={faBars} size="lg"/>
            </a>

            <div id="mySidenav" class="sidenav modal">
                <a href="javascript:void(0)" class="closebtn" onClick={this.closeNav}>&times;</a>
                <div class="menu-side-container">
                    <div class="logged-user">
                        <h3>Pedro Martinez</h3>
                        <p class="description">Laboratorio</p>
                    </div>
                    <ArrowMenu filled={this.state.filled} onClick={this.toggleLogin} /> 
                    <a href="javascript:void(0)" class="" onClick={this.openLoginMobile}><img src={loginIcon} /><p>INGRESAR</p></a>
                    <div id="modelo-menu-dos" class="ingresar-menu-div">
                        <a target="_blank" rel="noopener noreferrer" href={urlLogin.TRANSFERS} ><p>Transfer</p></a>
                    </div>
                    <NavLink exact to="/" onClick={this.closeNav}><img src={homeIcon} /><p>INICIO</p></NavLink>
                    <ArrowMenu filled={this.state.filled} onClick={this.handleClick} /> 
                    <NavLink to="/empresa" onClick={this.closeNav} className="empresa-link-menu">
                        <img src={businessIcon} />
                        <p>EMPRESA</p>    
                    </NavLink>
                    <div id="modelo-menu" class="modelo-menu-div">
                        <NavLink to="/modelo" onClick={this.closeNav}><p>Modelo de negocio</p></NavLink>
                    </div>
                    <NavLink to="/servicios" onClick={this.closeNav}><img src={serviceIcon} /><p>SERVICIOS</p></NavLink>
                    <NavLink to="/ventajas" onClick={this.closeNav}><img src={chartIcon} /><p>VENTAJAS</p></NavLink>
                    <NavLink to="/laboratorios" onClick={this.closeNav}><img src={flaskIcon} /><p>LABORATORIOS</p></NavLink>
                    <NavLink to="/contacto" onClick={this.closeNav}><img src={headsetBlackIcon} /><p>CONTACTO</p></NavLink>
                    <a href="#" onClick={this.closeNav} class="exit-link"><img src={exitIcon} /><p>Salir</p></a>
                </div>
            </div>
            
        </div>
        <Login />
        <div class="login-mobile">
            
        </div>
        
        </div>
        );
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js